import { useHistory, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { useRecoilValue, translationDataState, tourConfigsState } from '../../../store';

const MainWrap = styled.div<{ rtl?: boolean }>`
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: #ea475c;
  position: relative;
  margin-top: 41px;
  margin-left: 40px;
  margin-right: 40px;
  cursor: pointer;
  z-index: 1;
  direction: initial;

  @media screen and (max-width: 760px) {
    display: inline-block;
    float: initial;
    width: 100%;
    margin: 0;
    padding: 15px 22px 0 22px;
    position: relative;
    ${({ rtl }) => `${rtl ? 'text-align:right;' : ''}`};
  }
`;

const BackButton = (props: any) => {
  const { backFunction, location } = props;
  const { back = 'back' } = useRecoilValue(translationDataState);
  const { rtl } = useRecoilValue(tourConfigsState);
  const history = useHistory();
  const pushBack = () => {
    if (backFunction) {
      backFunction();
    } else {
      const paths = location.pathname.split('/');
      if (paths[paths.length - 1] === '') paths.pop();
      paths.pop();

      history.push(paths.join('/'));
    }
  };

  return (
    <MainWrap onClick={pushBack} rtl={rtl}>
      <i className="fas fa-chevron-left" /> {back}
    </MainWrap>
  );
};

export default withRouter(BackButton);
